import React from 'react';
import { ProductAddEdit } from './ProductAddEdit';

interface ProductViewProps {
  productId: string;
  onNavigate: (page: string, id?: string) => void;
}

export const ProductView: React.FC<ProductViewProps> = ({ productId, onNavigate }) => {
  return <ProductAddEdit productId={productId} onNavigate={onNavigate} viewOnly={true} />;
};
